// src/com/auto_plan_bind_group/AutoPlanBindGroupDict.js
import React from "react";
import { InputType, TableColumnType } from "../../value/AppConst";
import { styled } from '@mui/material/styles';
import IsValid from "../../value/IsValid";

const NameBlock = styled('div')({
    display: 'inline-flex', minWidth: 120, textAlign: 'center',
    backgroundColor: '#eee', borderRadius: 5, padding: '4px 2px 4px 1px'
});

const StoreIdBox = styled('span')({
    color:'#777', marginRight: 3, marginLeft: 5, fontSize:'0.7rem'
});

const PlaceNameBox = styled('span')({
    flexGrow: 1, textAlign: 'center', fontSize:'0.8rem'
});

const LinkBar = styled('div')({
    display: 'inline-block', width: 30, height: 5, backgroundColor: '#ddf'
});

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    groupOrderNum : {
		id: 'groupOrderNum', label: '그룹순서',
		type: InputType.number, required: true, toAdd: false, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    dcCd : {
		id: 'dcCd', label: '센터',
		type: InputType.text, required: true, toAdd: false, toEdit: true,
	}, // varchar(3)
    condiVehTypeId : {
		id: 'condiVehTypeId', label: '차종',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
        labelKey: 'vehTypeName', valueKey: 'vehTypeId',
	}, // varchar(10)
    condiPtCnt : {
		id: 'condiPtCnt', label: '조건Pallet',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= 1 && value <= 100},
	}, // int(11)
    vehTypeName : {
		id: 'vehTypeName', label: '조건차종',
	}, // varchar(50)
    storeSetList: {
        id: 'storeSetList', label: '동적점포리스트',
        required: true, toAdd: true, toEdit: true,
        check: (value) => value && value.length > 1,
    }
};

function printStores(rec, idx, value) {
    const dcName = rec.dcName;
    return (
        <div>
            <NameBlock><PlaceNameBox>{dcName}</PlaceNameBox></NameBlock>
            {
                rec.storeSetList.map((store, idx) => {
                    return (
                        <React.Fragment key={store.storeId}>
                        <LinkBar key={idx}/>
                        <NameBlock>
                            <StoreIdBox>[{store.storeId}]</StoreIdBox>
                            <PlaceNameBox>{store.storeName}</PlaceNameBox>
                        </NameBlock>
                        </React.Fragment>
                    );
                })
            }
        </div>
    );
}

/**
 * AUTO_PLAN_BIND_GROUP React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-10-15 14:04:11 using DbdbTap
 */
export const AutoPlanBindGroupDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '동적점포그룹 등록 오류',
        Edit: '동적점포그룹 수정 오류',
        Remove: '동적점포그룹 삭제 오류',
        Get: '동적점포 조회 오류',
    },
    tableProps: {
        tableId: 'autoPlanBindGroupTable',
        uniqueKey: 'groupOrderNum',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: true,
            hideColumnConfig: true,
            hideBubble: true,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'groupOrderNum', label: '순번', width: 50, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            //{ id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'condiVehTypeId', label: Dict.condiVehTypeId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeName', label: Dict.vehTypeName.label, width: 100, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'condiPtCnt', label: Dict.condiPtCnt.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.INTEGER} },
            //{ id: 'regDate', label: "regDate", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            //{ id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            {
                id: 'storeSetList', label: '동적 점포 설정', width: 460, show: true,
                option:{
                    align: 'left',
                    print: printStores,
                }
            },
        ]
    },
};
